import { AuthLayout } from '@ui/components/layouts';
import { ChangePasswordContainer } from '@modules/change-password/containers/change_password_container';
import { ChangePasswordForm } from '@modules/change-password/views/change_password_view';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { webAppRoutes } from '@/src/lib/navigation/containerPaths';

export function ChangePasswordScreen() {
  const navigate = useNavigate();

  return (
    <AuthLayout>
      <ChangePasswordContainer
        View={ChangePasswordForm}
        onSuccess={(message) => toast.success(message)}
        onError={(message) => toast.error(message)}
        onSuccessNavigate={() => navigate(webAppRoutes.settings, { replace: true })}
        onNavigateBack={() => navigate(webAppRoutes.settings)}
        useFormSubmitHandler
      />
    </AuthLayout>
  );
}
